var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "column no-padding" }, [
    _c(
      "div",
      {
        staticClass: "row col-grow",
        class: { "hide-low-display": _vm.noteInputExpanded }
      },
      [
        _c(
          "q-scroll-area",
          {
            staticClass: "full-width",
            attrs: {
              "thumb-style": {
                width: "5px",
                "background-color": "#555",
                opacity: 1
              }
            }
          },
          [
            _vm.hasNotes || _vm.preliminaryNote
              ? _c(
                  "q-list",
                  {
                    staticClass: "q-pa-none text-select",
                    attrs: { "no-border": "", separator: "" }
                  },
                  [
                    _vm._l(_vm.notes, function(note) {
                      return _c("note-item", {
                        key: note.id,
                        attrs: {
                          note: note,
                          updateNoteMethod: _vm.updateNoteMethod,
                          deleteNoteMethod: _vm.deleteNoteMethod
                        }
                      })
                    }),
                    _vm.preliminaryNote
                      ? _c("note-item", {
                          attrs: {
                            note: _vm.preliminaryNote,
                            updateNoteMethod: _vm.updateNoteMethod,
                            deleteNoteMethod: _vm.deleteNoteMethod,
                            disabled: ""
                          }
                        })
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            !(_vm.hasNotes || _vm.preliminaryNote) && !_vm.hideEmptyState
              ? [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row justify-center items-center col-grow q-pt-lg"
                    },
                    [
                      _c("div", { staticClass: "text-center" }, [
                        _c("img", {
                          attrs: {
                            src: require("assets/emptystates/notes_empty.svg"),
                            height: "100px"
                          }
                        }),
                        _c("h6", { staticClass: "q-my-md text-faded" }, [
                          _vm._v(_vm._s(_vm.$t("no_notes")))
                        ])
                      ])
                    ]
                  )
                ]
              : _vm._e()
          ],
          2
        )
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [{ name: "is-user", rawName: "v-is-user" }],
        staticClass: "q-my-md q-px-lg"
      },
      [
        _c("expandable-textarea", {
          attrs: {
            classes: ["block", "full-width"],
            placeholder: _vm.$t("write_note")
          },
          on: {
            expand: function($event) {
              _vm.noteInputExpanded = true
            },
            collapse: function($event) {
              _vm.noteInputExpanded = false
            }
          },
          model: {
            value: _vm.noteText,
            callback: function($$v) {
              _vm.noteText = $$v
            },
            expression: "noteText"
          }
        }),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.noteInputExpanded,
                expression: "noteInputExpanded"
              }
            ],
            staticClass: "row justify-end q-mt-sm"
          },
          [
            _c(
              "q-btn",
              {
                attrs: { flat: "", color: "white", "text-color": "light" },
                on: { click: _vm.handleCancel }
              },
              [_vm._v(_vm._s(_vm.$t("cancel")))]
            ),
            _c(
              "q-btn",
              {
                attrs: { flat: "", color: "white", "text-color": "faded" },
                on: { click: _vm.handleSave }
              },
              [_vm._v(_vm._s(_vm.$t("save")))]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }